import { AppEvents } from 'common-events';
import { clearStore } from '../actions/exclusions-actions';

export const setupExclusionsListeners = () => {
  document.addEventListener(AppEvents.Scan.ScanStart, () => {
    clearStore();
  });
};
